// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar_graph_container {
    display: flex;
    flex-direction: column;
    align-items: start;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.bar_graph_title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.bar_graph_header {
    display: flex;
    width: 100%;
    padding: 10px 0px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/BarGraph/BarGraph.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".bar_graph_container {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.bar_graph_title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.bar_graph_header {\n    display: flex;\n    width: 100%;\n    padding: 10px 0px;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
